// src/components/CustomTripSection.js

import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import videoBackground from '../assets/video/expo.mp4';

const CustomTripSection = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative', // Parent for the absolute positioned children
        width: '100vw',
        height: { xs: '70vh', md: '80vh' }, // Use viewport height, slightly less on mobile
        display: 'flex',       // Use flexbox for easy centering
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',    // Hide video overflow
        color: 'white',        // Default text color for children
      }}
    >
      {/* 1. The Video Background - Bottom Layer */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover', // Ensures video covers the area without distortion
          zIndex: 1,          // Place it at the bottom of the stack
        }}
      >
        <source src={videoBackground} type="video/mp4" />
        Your browser does not support the video tag.
      </Box>

      {/* 2. The Dark Overlay - Middle Layer */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)', // 40% black overlay
          zIndex: 2, // Place it above the video
        }}
      />

      {/* 3. The Content - Top Layer */}
      <Container
        maxWidth="md" // Constrains the text width for readability
        sx={{
          position: 'relative', // Needed for z-index to work
          zIndex: 3,            // Place it on top of the overlay
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontFamily: '"Cormorant Garamond", "Georgia", serif',
            fontWeight: 700,
            // Your responsive font sizes are perfect!
            fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
            lineHeight: 1.1,
            mb: 3, // Increased margin-bottom a bit
            textShadow: '0 2px 10px rgba(0,0,0,0.5)',
          }}
        >
          Journeys That Touch the Soul
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            maxWidth: '650px', // Slightly increased max-width
            mx: 'auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7,
            textShadow: '0 1px 5px rgba(0,0,0,0.4)',
            // Added responsive font size for the paragraph
            fontSize: { xs: '1rem', md: '1.15rem' },
          }}
        >
          Explore our curated travel themes, each a doorway to the authentic heart of Cylon. Find the experience that speaks to you.
        </Typography>
      </Container>
    </Box>
  );
};

export default CustomTripSection;